import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {CryptoService} from './crypto.service';
import {NewOrderParams, OrderReceiptChkParams} from '../my-features/purchase/purchase.model';

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  ReadPurchaseHistory(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/order/read`, params);
  }

  ReadPackage(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/package/read`, params);
  }

  NewOrder(params): Observable<any> {
    const data: NewOrderParams = {
      ...params,
      otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params),
    };
    return this.http.post<any>(`${environment.apiIotUrl}/order/add`, data);
  }

  OrderCheckReceipt(params): Observable<any> {
    const data: OrderReceiptChkParams = {
      ...params,
      otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params),
    };
    return this.http.post<any>(`${environment.apiIotUrl}/order/check/receipt`, data);
  }

  ReadPurchaseOtp(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/purchase/otp/read`, params);
  }

  // 調整 Account 頁面使用之 API不從Nodejs拿資料
  CreatePayPalAgreement(params): Observable<any> {
    return this.http.post<any>(`/api/create-billing-agreements`, params);
  }
}
